import React, { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'

function useOutClick(ref, props) {
    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                props.action()
            }
        }
        document.addEventListener('click', handleClickOutside)
        return () => {
            document.removeEventListener('click', handleClickOutside)
        }
    }, [ref])
}

function OutClick(props) {
    const wrapperRef = useRef(null)
    useOutClick(wrapperRef, props)

    return <div ref={wrapperRef}>{props.children}</div>
}

OutClick.propTypes = {
    children: PropTypes.element.isRequired,
}

export default OutClick



// WEBPACK FOOTER //
// ./src/header/component/search/outSide.js